(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["micrositescripts"] = factory();
	else
		root["Site"] = root["Site"] || {}, root["Site"]["micrositescripts"] = factory();
})(self, () => {
return 